import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  inject,
  Input,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { SessionFacade } from '@shared/store/session.facade';
import { IconColor, IconWeight } from '@widgets/eop-icon/eop-icon.component';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { HeaderMenuComponent } from '../header-menu/header-menu.component';
import { QuickAccessComponent } from '../quick-access/quick-access/quick-access.component';

@Component({
  selector: 'eop-global-header',
  templateUrl: 'global-header.component.html',
  styleUrls: ['global-header.component.scss'],
  standalone: false,
})
export class GlobalHeaderComponent implements AfterViewInit, OnDestroy {
  @ViewChild('searchBar')
  searchBar: QuickAccessComponent;

  @ViewChild(HeaderMenuComponent)
  menu: HeaderMenuComponent;

  @Input()
  isFullWidth = false;

  readonly IconWeight = IconWeight;
  readonly IconColor = IconColor;

  private readonly sessionFacade: SessionFacade = inject(SessionFacade);
  private readonly cdr: ChangeDetectorRef = inject(ChangeDetectorRef);
  private readonly unsubscribe$ = new Subject<void>();

  ngAfterViewInit(): void {
    this.sessionFacade.sidebarCollapsed$.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      this.cdr.detectChanges();
    });

    //do not remove the setTimout
    //it's fixing the NG0100:ExpressionChangedAfterItHasBeenCheckedError
    setTimeout(() => {
      this.searchBar?.popoverVisible$
        ?.pipe(takeUntil(this.unsubscribe$))
        ?.subscribe((opened: boolean) => {
          if (opened) {
            this.sessionFacade.closeMessages();
          }
        });
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  collapseMenu(): void {
    this.menu.collapseMenu();
  }
}
